import { Roles } from '@/entities/Roles';
import { assignOwnProperties } from '@/utils/assignOwnProperties';

export interface IZollUser {
  companyId: string;
  fullName: string;
  tenantKey: string;
  tenantName: string;
  userKey: string;
  userName: string;
  userRoles: string[];
}

export interface IUser extends Omit<IZollUser, 'userRoles'> {
  companyId: string;
  fullName: string;
  tenantKey: string;
  tenantName: string;
  roles: Roles;
}

export type UserLike = Partial<IZollUser> | IZollUser & IUser;

export class User implements IUser {
  companyId: string;

  fullName: string;

  tenantKey: string;

  tenantName: string;

  userKey: string;

  userName: string;

  roles: Roles;

  constructor(user?: UserLike) {
    assignOwnProperties(this, (this.constructor as typeof User).normalize(user));
  }

  static create(user?: User | UserLike) {
    if (user instanceof User) {
      return user;
    }

    return new this(user);
  }

  static defaults(): IUser {
    return {
      companyId: '',
      fullName: '',
      tenantKey: '',
      tenantName: '',
      userKey: '',
      userName: '',
      roles: Roles.create(),
    };
  }

  static normalize(user?: User | UserLike): IUser {
    // Use empty defaults to ensure all properties exist.
    const normalized = <IUser> { ...this.defaults() };

    if (user instanceof User) {
      return user;
    }

    // Merge in only supported property values.
    const roles = Roles.create(user?.userRoles);
    assignOwnProperties(normalized, user);
    normalized.roles = roles;

    return normalized;
  }
}
